'use strict';

import WatchButton from './components/WatchButton.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('watch-button', WatchButton);

    }
}